var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main-header',{attrs:{"nowtab":"play"}}),_c('main',[_c('div',[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('a-button',{attrs:{"icon":"plus"}},[_vm._v("加入收藏")])],1),_c('div')]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }